var SupportBasePresentation, SupportGetawaysVoucherPresenterPresentation, SupportGetawaysVoucherStatusAndNotesPresentation, SupportPresenterUtilPresentation,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePresentation = require('./base');

SupportPresenterUtilPresentation = require('./presenter_util');

SupportGetawaysVoucherStatusAndNotesPresentation = require('./getaways_voucher_messages');

SupportGetawaysVoucherPresenterPresentation = (function(superClass) {
  extend(SupportGetawaysVoucherPresenterPresentation, superClass);

  function SupportGetawaysVoucherPresenterPresentation() {
    return SupportGetawaysVoucherPresenterPresentation.__super__.constructor.apply(this, arguments);
  }

  SupportGetawaysVoucherPresenterPresentation.prototype.getLookupObject = function() {
    return SupportGetawaysVoucherStatusAndNotesPresentation;
  };

  return SupportGetawaysVoucherPresenterPresentation;

})(SupportBasePresentation);

module.exports = SupportGetawaysVoucherPresenterPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9nZXRhd2F5c192b3VjaGVyX3ByZXNlbnRlci5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC9wcmVzZW50ZXJzL2dldGF3YXlzX3ZvdWNoZXJfcHJlc2VudGVyLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLHdKQUFBO0VBQUE7OztBQUFBLHVCQUFBLEdBQTBCLE9BQUEsQ0FBUSxRQUFSOztBQUMxQixnQ0FBQSxHQUFtQyxPQUFBLENBQVEsa0JBQVI7O0FBQ25DLGdEQUFBLEdBQW1ELE9BQUEsQ0FBUSw2QkFBUjs7QUFFN0M7Ozs7Ozs7d0RBQ0wsZUFBQSxHQUFpQixTQUFBO1dBQ2hCO0VBRGdCOzs7O0dBRHdDOztBQUkxRCxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
